/*
 * neccst-contact.js
 * Lightweight client-side validation for the NECCST contact form.
 * Required fields: Email + Message. Name, Phone and Topic are optional.
 * The Shopify {% form 'contact' %} handles the actual submission and
 * server-side success/error; this script only pre-validates and shows
 * the inline error banner before the form is submitted.
 */
(function () {
  'use strict';

  function init() {
    var form = document.getElementById('neccst-contact-form');
    if (!form) return;

    var emailField = form.querySelector('[name="contact[email]"]');
    var bodyField  = form.querySelector('[name="contact[body]"]');
    var errorBanner = document.getElementById('neccst-contact-error');

    if (!emailField || !bodyField) return;

    function isEmailValid(val) {
      var s = val.trim();
      if (!s) return false;
      var at = s.indexOf('@');
      if (at < 1) return false;
      var dot = s.indexOf('.', at);
      return dot > at + 1 && dot < s.length - 1;
    }

    function setInvalid(el, bad) {
      el.classList.toggle('cf-invalid', bad);
      el.setAttribute('aria-invalid', bad ? 'true' : 'false');
    }

    function clearInvalid(el) {
      setInvalid(el, false);
    }

    /* Live clear on input */
    emailField.addEventListener('input', function () {
      if (emailField.value.trim()) clearInvalid(emailField);
    });
    bodyField.addEventListener('input', function () {
      if (bodyField.value.trim()) clearInvalid(bodyField);
    });

    form.addEventListener('submit', function (e) {
      var emailBad = !isEmailValid(emailField.value);
      var bodyBad  = !bodyField.value.trim();

      setInvalid(emailField, emailBad);
      setInvalid(bodyField,  bodyBad);

      if (emailBad || bodyBad) {
        e.preventDefault();
        if (errorBanner) {
          errorBanner.hidden = false;
          errorBanner.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        /* Focus first invalid field for accessibility */
        if (emailBad) {
          emailField.focus();
        } else {
          bodyField.focus();
        }
      } else {
        if (errorBanner) errorBanner.hidden = true;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
